var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_143_3574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2625 0H21.7333C22.4292 0 22.9958 0.566667 22.9958 1.2625V14.7333C22.9958 15.4292 22.4292 15.9958 21.7333 15.9958H1.2625C0.566667 16 0 15.4333 0 14.7375V1.2625C0 0.566667 0.566667 0 1.2625 0Z",
    fill: "#B22234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00833333 1.13745H22.9958C23 1.17912 23.0042 1.22078 23.0042 1.26662V2.49162H0V1.26245C0 1.22078 0.00416667 1.17912 0.00833333 1.13745ZM23 3.61245V4.96245H0V3.61245H23ZM23 6.08745V7.43745H0V6.08745H23ZM23 8.56245V9.91245H0V8.56245H23ZM23 11.0375V12.3875H0V11.0375H23ZM23 13.5125V14.7333C23 14.775 22.9958 14.8208 22.9917 14.8624H0.00833333C0.00416667 14.8249 0 14.7791 0 14.7374V13.5166H23V13.5125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 0V8.61667H0V1.2625C0 0.566667 0.566667 0 1.2625 0H8.66667Z",
    fill: "#3C3B6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.511849 1.19165L0.799349 2.08748L0.0410156 1.53332H0.982682L0.220182 2.08748L0.511849 1.19165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.511849 2.92505L0.799349 3.82088L0.0410156 3.26672H0.982682L0.220182 3.82088L0.511849 2.92505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.511849 4.65845L0.799349 5.55428L0.0410156 5.00011H0.982682L0.220182 5.55428L0.511849 4.65845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.511849 6.3916L0.799349 7.28743L0.0410156 6.73327H0.982682L0.220182 7.28743L0.511849 6.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52943 0.324951L1.82109 1.22078L1.05859 0.666618H2.00443L1.23776 1.22078L1.52943 0.324951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52943 2.05835L1.82109 2.95418L1.05859 2.40002H2.00443L1.23776 2.95418L1.52943 2.05835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52943 3.79175L1.82109 4.68758L1.05859 4.13341H2.00443L1.23776 4.68758L1.52943 3.79175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52943 5.5249L1.82109 6.42074L1.05859 5.86657H2.00443L1.23776 6.42074L1.52943 5.5249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.52943 7.2583L1.82109 8.15413L1.05859 7.59997H2.00443L1.23776 8.15413L1.52943 7.2583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55091 1.19165L2.84258 2.08748L2.08008 1.53332H3.02174L2.25924 2.08748L2.55091 1.19165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55091 2.92505L2.84258 3.82088L2.08008 3.26672H3.02174L2.25924 3.82088L2.55091 2.92505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55091 4.65845L2.84258 5.55428L2.08008 5.00011H3.02174L2.25924 5.55428L2.55091 4.65845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.55091 6.3916L2.84258 7.28743L2.08008 6.73327H3.02174L2.25924 7.28743L2.55091 6.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57044 0.324951L3.85794 1.22078L3.09961 0.666618H4.04128L3.27878 1.22078L3.57044 0.324951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57044 2.05835L3.85794 2.95418L3.09961 2.40002H4.04128L3.27878 2.95418L3.57044 2.05835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57044 3.79175L3.85794 4.68758L3.09961 4.13341H4.04128L3.27878 4.68758L3.57044 3.79175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57044 5.5249L3.85794 6.42074L3.09961 5.86657H4.04128L3.27878 6.42074L3.57044 5.5249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57044 7.2583L3.85794 8.15413L3.09961 7.59997H4.04128L3.27878 8.15413L3.57044 7.2583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58802 1.19165L4.87969 2.08748L4.11719 1.53332H5.05885L4.29635 2.08748L4.58802 1.19165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58802 2.92505L4.87969 3.82088L4.11719 3.26672H5.05885L4.29635 3.82088L4.58802 2.92505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58802 4.65845L4.87969 5.55428L4.11719 5.00011H5.05885L4.29635 5.55428L4.58802 4.65845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.58802 6.3916L4.87969 7.28743L4.11719 6.73327H5.05885L4.29635 7.28743L4.58802 6.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60755 0.324951L5.89922 1.22078L5.13672 0.666618H6.07839L5.31589 1.22078L5.60755 0.324951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60755 2.05835L5.89922 2.95418L5.13672 2.40002H6.07839L5.31589 2.95418L5.60755 2.05835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60755 3.79175L5.89922 4.68758L5.13672 4.13341H6.07839L5.31589 4.68758L5.60755 3.79175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60755 5.5249L5.89922 6.42074L5.13672 5.86657H6.07839L5.31589 6.42074L5.60755 5.5249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.60755 7.2583L5.89922 8.15413L5.13672 7.59997H6.07839L5.31589 8.15413L5.60755 7.2583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62513 1.19165L6.9168 2.08748L6.1543 1.53332H7.09596L6.33763 2.08748L6.62513 1.19165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62513 2.92505L6.9168 3.82088L6.1543 3.26672H7.09596L6.33763 3.82088L6.62513 2.92505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62513 4.65845L6.9168 5.55428L6.1543 5.00011H7.09596L6.33763 5.55428L6.62513 4.65845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.62513 6.3916L6.9168 7.28743L6.1543 6.73327H7.09596L6.33763 7.28743L6.62513 6.3916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64662 0.324951L7.93828 1.22078L7.17578 0.666618H8.11745L7.35495 1.22078L7.64662 0.324951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64662 2.05835L7.93828 2.95418L7.17578 2.40002H8.11745L7.35495 2.95418L7.64662 2.05835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64662 3.79175L7.93828 4.68758L7.17578 4.13341H8.11745L7.35495 4.68758L7.64662 3.79175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64662 5.5249L7.93828 6.42074L7.17578 5.86657H8.11745L7.35495 6.42074L7.64662 5.5249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64662 7.2583L7.93828 8.15413L7.17578 7.59997H8.11745L7.35495 8.15413L7.64662 7.2583Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_3574"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsFlag);
export default __webpack_public_path__ + "static/media/US_flag.55e3e7b6b99cc5eb48c7374cf76f5322.svg";
export { ForwardRef as ReactComponent };